import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
const PaymentSuccess = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const planType = searchParams.get("planType");
    const bookingID = searchParams.get("BookingID");
    useEffect(() => {
        const timer = setTimeout(() => {
            if (planType === "1") {
                navigate(`/flight/booking-confirmation/${bookingID}`);
            } else if (planType === "2") {
                navigate(`/hotel/paymentconfirmation/${bookingID}`);
            } else {
                navigate(`/finance/ledger`);
            }
        }, 3000); // 50 seconds

        return () => clearTimeout(timer); // cleanup
    }, [planType, bookingID, navigate]);
    return (
        <div className="bg-gray-100 text-gray-800 relative min-h-screen">
            <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-6 space-y-6">
                <section className="bg-white rounded-lg shadow p-6 w-full text-center">
                    <div className="mb-2 flex justify-center">
                        <img
                            src="/payment process.gif"
                            className="h-[230px]"
                            alt="Payment Process"
                        />
                    </div>

                    <p className="text-gray-600 text-sm mb-6 leading-relaxed">
                        Your payment is being processed.<br />
                        Please wait while we redirect you to the confirmation page.<br />
                        Kindly do not refresh, go back, or close this window.

                    </p>

                </section>
            </main>

        </div>
    );
};

export default PaymentSuccess;
